import {
  OrderNumber,
  OrderStatus,
  RefundSummary,
} from '@web/shared/module/shop';
import { Guid, Nillable } from '@web/utils';
import { AdminSubscriptionOrderType } from '../enums/admin-subscription-order-type';

export class AdminSubscriptionOrderCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      number: OrderNumber;
      status: OrderStatus;
      totalItems: number;
      totalPrice: number;
      refundSummary?: Nillable<RefundSummary>;
      createdAt: Date;
      type: AdminSubscriptionOrderType;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get type(): AdminSubscriptionOrderType {
    return this.data.type;
  }
}
